//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios from 'axios'
import moment from 'moment'
import {
  saveAs
} from 'file-saver'
export default {
  components: {},

  data () {
    return {
      exoprt_open: false,
      ex_date_from: '',
      ex_ef_data: [],
      ex_qty_data: [],
      ex_ef_target: 0,
      ex_actual_actual: 0,
      ex_qty_actual1: 0,
      ex_qty_actual2: 0,
      export_bu: 'G1',
      pagename: 'page05',
      DATA_TYPE: 'ALL',
      DDATA_TYPE: ['ALL', 'EFFICIENCY', 'QUALITY'],
      visible1: false,
      date: '',
      location: 'G1',
      locations: ['G1', 'G2', 'G3', 'G4', 'G5', 'VN2', 'INDO'],
      department: '',
      departments: [],
      departments_all: [],
      dataEff: [],
      dataQuality: [],
      eff_target: 0,
      eff_actual: 0,
      eff_rate: 0,
      qceff_per: 0,
      qua_good: 0,
      qua_actual: 0,
      qua_rate: 0,
      mtd_eff: 0,
      mtd_qua: 0,
      aa: 0,
      bb: 0
    }
  },
  created () {
    this.CheckLocal()
    this.LoadFirst()
  },
  async mounted () {
    this.getloc()
  },
  watch: {
    location: function (newValue, oldValue) {
      this.department = ''
      this.LoadDept()
      this.LoadQuality()
      this.LoadEff()
    },
    department: function (newValue, oldValue) {
      this.LoadQuality()
      this.LoadEff()
    },
    date: function (newValue, oldValue) {
      this.LoadQuality()
      this.LoadEff()
    }
  },
  computed: {

  },
  methods: {
    LoadFirst () {
      //
      this.pulling = setTimeout(() => {
        this.chkAuthen('', '')
        this.CurrDate()
        this.LoadDept()
        this.pullData()
      }, 1000)
    },
    // eslint-disable-next-line camelcase
    async Export_excel (type_download) {
      this.visible = true
      // eslint-disable-next-line camelcase
      let columns_width = []
      // eslint-disable-next-line camelcase
      let columns_width2 = []
      for (let x = 0; x < 20; x++) {
        // eslint-disable-next-line eqeqeq
        columns_width.push({
          width: 25
        })
        columns_width2.push({
          width: 25
        })
      }
      const ExcelJS = require('exceljs')
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet('EFFICIENCY')
      const ws2 = wb.addWorksheet('QUALITY')
      // eslint-disable-next-line camelcase
      ws.columns = columns_width
      // eslint-disable-next-line camelcase
      ws2.columns = columns_width2
      console.log(ws)
      console.log(ws2)
      // eslint-disable-next-line camelcase, no-inner-declarations
      function add_row (row_num, col_num, text, bg_color) {
        ws.getCell(row_num, col_num).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: bg_color
          }
        }
        ws.getCell(row_num, col_num).value = text
        ws.getCell(row_num, col_num).font = {
          family: 4,
          size: 14,
          underline: false,
          bold: true
        }
        ws.getCell(row_num, col_num).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }
      }
      // eslint-disable-next-line no-inner-declarations, camelcase
      function add_row2 (row_num, col_num, text, bg_color) {
        ws2.getCell(row_num, col_num).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: bg_color
          }
        }
        ws2.getCell(row_num, col_num).value = text
        ws2.getCell(row_num, col_num).font = {
          family: 4,
          size: 14,
          underline: false,
          bold: true
        }
        ws2.getCell(row_num, col_num).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }
      }
      // add_row(1, 1, 'aaaa')
      // eslint-disable-next-line camelcase, no-inner-declarations
      function add_row_mergeCells (row1, col1, row2, col2, text, bg_color, text_color, border) {
        ws.mergeCells(row1, col1, row2, col2)
        ws.getCell(row1, col1).value = text
        ws.getCell(row1, col1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: bg_color
          }
        }
        ws.getCell(row1, col1).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }
        ws.getCell(row1, col1).font = {
          family: 4,
          size: 14,
          underline: false,
          bold: true,
          color: {
            argb: text_color
          }
        }
        if (border) {
          ws.getCell(row1, col1).border = {
            top: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            },
            left: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            },
            bottom: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            },
            right: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            }
          }
        }
      }
      // eslint-disable-next-line camelcase, no-inner-declarations
      function add_row_mergeCells2 (row1, col1, row2, col2, text, bg_color, text_color, border) {
        ws2.mergeCells(row1, col1, row2, col2)
        ws2.getCell(row1, col1).value = text
        ws2.getCell(row1, col1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: bg_color
          }
        }
        ws2.getCell(row1, col1).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }
        ws2.getCell(row1, col1).font = {
          family: 4,
          size: 14,
          underline: false,
          bold: true,
          color: {
            argb: text_color
          }
        }
        if (border) {
          ws2.getCell(row1, col1).border = {
            top: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            },
            left: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            },
            bottom: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            },
            right: {
              style: 'double',
              color: {
                argb: 'ffffff'
              }
            }
          }
        }
      }
      // 'ALL', 'EFFICIENCY', 'QUALITY'
      // eslint-disable-next-line camelcase, eqeqeq
      if (type_download == 'EFFICIENCY' || type_download == 'ALL') {
        // eslint-disable-next-line eqeqeq, camelcase
        if (type_download != 'ALL') {
          wb.removeWorksheet(2)
        }
        add_row_mergeCells(1, 1, 3, 1, 'Line', '1916FF', 'ffffff', true, ws)
        add_row_mergeCells(1, 4, 3, 4, 'Eff. %', '1916FF', 'ffffff', true)
        add_row_mergeCells(1, 2, 1, 2, 'Target', '1916FF', 'ffffff', true)
        add_row_mergeCells(1, 3, 1, 3, 'Actual', '1916FF', 'ffffff', true)
        add_row_mergeCells(2, 2, 2, 2, 'Output', '1916FF', 'ffffff', true)
        add_row_mergeCells(2, 3, 2, 3, 'Output', '1916FF', 'ffffff', true)
        add_row_mergeCells(3, 2, 3, 2, this.ex_ef_target, '1916FF', 'ffffff', true)
        add_row_mergeCells(3, 3, 3, 3, this.ex_actual_actual, '1916FF', 'ffffff', true)
        // eslint-disable-next-line camelcase
        let e_row = 4
        this.ex_ef_data.forEach(e => {
          add_row(e_row, 1, e.line_name, 'ffffff')
          add_row(e_row, 2, e.qa_target, 'ffffff')
          add_row(e_row, 3, e.wcs_actual_qty, 'ffffff')
          add_row(e_row, 4, e.eff + '%', 'ffffff')
          // eslint-disable-next-line camelcase
          e_row++
        })
      }
      // eslint-disable-next-line camelcase, eqeqeq
      if (type_download == 'QUALITY' || type_download == 'ALL') {
        // eslint-disable-next-line eqeqeq, camelcase
        if (type_download != 'ALL') {
          wb.removeWorksheet(1)
        }
        add_row_mergeCells2(1, 1, 3, 1, 'Line', '1916FF', 'ffffff', true)
        add_row_mergeCells2(1, 4, 3, 4, 'Rft. %', '1916FF', 'ffffff', true)
        add_row_mergeCells2(1, 2, 1, 2, 'Actual', '1916FF', 'ffffff', true)
        add_row_mergeCells2(1, 3, 1, 3, 'Actual', '1916FF', 'ffffff', true)
        add_row_mergeCells2(2, 2, 2, 2, 'Output', '1916FF', 'ffffff', true)
        add_row_mergeCells2(2, 3, 2, 3, 'Good', '1916FF', 'ffffff', true)
        add_row_mergeCells2(3, 2, 3, 2, this.ex_qty_actual1, '1916FF', 'ffffff', true)
        add_row_mergeCells2(3, 3, 3, 3, this.ex_qty_actual2, '1916FF', 'ffffff', true)
        // eslint-disable-next-line camelcase
        let e_row = 4
        this.ex_qty_data.forEach(e => {
          add_row2(e_row, 1, e.line_name, 'ffffff')
          add_row2(e_row, 2, e.total_qa_actual, 'ffffff')
          add_row2(e_row, 3, e.total_qa_good, 'ffffff')
          add_row2(e_row, 4, this.calRateEff(e.total_qa_actual, e.total_qa_good) + '%', 'ffffff')
          // eslint-disable-next-line camelcase
          e_row++
        })
      }
      wb.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        saveAs(blob, 'EXPORT_EFFICIENCY&QUALITY_(' + this.export_bu + ')_' + this.ex_date_from + '_.xlsx')
      })
      this.visible = false
    },
    async Excel_Detail (DATA_TYPE) {
      // eslint-disable-next-line eqeqeq
      if (DATA_TYPE == 'EFFICIENCY' || DATA_TYPE == 'ALL') {
        await this.Excel_LoadEff(DATA_TYPE)
      }
      // eslint-disable-next-line eqeqeq
      if (DATA_TYPE == 'QUALITY') {
        await this.Excel_LoadQuality(DATA_TYPE)
      }
    },
    async Excel_LoadEff (DATA_TYPE) {
      try {
        this.$q.loading.show()
        let params = new FormData()
        params.append('uid', 'IT')
        params.append('location', this.export_bu)
        params.append('dept', '')
        params.append('jobdate', moment(this.ex_date_from).format('YYYY/MM/DD'))
        axios({
          method: 'post',
          url: this.$api + 'ws_shopfloor.php/getdatasammary',
          // url: 'http://localhost/nygcontrolroom/api/ws_shopfloor.php/getdatasammary',
          data: params
        }).then((res) => {
          console.log('ex getdatasammary')
          console.log(res.data)
          let arr = res.data.vdata

          let result = []
          arr.forEach(function (a) {
            if (!this[a.line_name]) {
              this[a.line_name] = {
                line_name: a.line_name,
                job: 0,
                qa_target: 0,
                wcs_actual_qty: 0,
                sam: 0,
                minute: 0,
                worker: 0,
                eff: 0,
                input_minutes: 0,
                output_minutes: 0
              }
              result.push(this[a.line_name])
            }
            this[a.line_name].job += 1
            this[a.line_name].qa_target += parseFloat(a.qa_target)
            this[a.line_name].wcs_actual_qty += parseFloat(a.wcs_actual_qty)
            this[a.line_name].sam += parseFloat(
              (parseFloat(a.wcs_actual_qty) * parseFloat(a.smv)).toFixed(2)
            )
            this[a.line_name].minute += parseFloat(a.time_minutes)
            this[a.line_name].worker += parseFloat(a.worker)
            this[a.line_name].input_minutes += parseFloat(a.input_minutes)
            this[a.line_name].output_minutes += parseFloat(a.output_minutes)
            this[a.line_name].eff = parseFloat(a.eff)
          }, Object.create(null))

          this.ex_ef_data = result
          let aa = 0
          let bb = 0
          result.forEach(function (a) {
            aa += a.qa_target
            bb += a.wcs_actual_qty
          })
          this.ex_ef_target = aa
          this.ex_actual_actual = bb

          console.log(this.ex_ef_data)
          console.log(this.ex_ef_target)
          console.log(this.ex_actual_actual)

          // eslint-disable-next-line eqeqeq
          if (DATA_TYPE == 'EFFICIENCY') {
            this.Export_excel(DATA_TYPE)
          }
          // eslint-disable-next-line eqeqeq
          if (DATA_TYPE == 'QUALITY' || DATA_TYPE == 'ALL') {
            this.Excel_LoadQuality(DATA_TYPE)
          }
          // eslint-disable-next-line camelcase
          // return re_data
          this.$q.loading.hide()
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.$q.loading.hide()
      }
    },
    async Excel_LoadQuality (DATA_TYPE) {
      try {
        this.$q.loading.show()
        this.ex_qty_actual1 = 0
        this.ex_qty_actual2 = 0
        let params = new FormData()
        params.append('uid', 'IT')
        params.append('location', this.export_bu)
        params.append('dept', '')
        params.append('jobdate', moment(this.ex_date_from).format('YYYY/MM/DD'))
        axios({
          method: 'post',
          url: this.$api + 'ws_shopfloor.php/getdataqc',
          data: params
        }).then((res) => {
          this.ex_qty_data = res.data.vdata
          for (let i = 0; i < this.ex_qty_data.length; i++) {
            this.ex_qty_actual1 += parseInt(this.ex_qty_data[i].total_qa_actual)
            this.ex_qty_actual2 += parseInt(this.ex_qty_data[i].total_qa_good)
          }
          console.log(this.ex_qty_data)
          console.log(this.ex_qty_actual1)
          console.log(this.ex_qty_actual2)
          this.Export_excel(DATA_TYPE)
        })
        this.$q.loading.hide()
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.$q.loading.hide()
      }
    },
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (
        // eslint-disable-next-line eqeqeq
          currentdate.getMinutes() % 5 == 0 &&
                    // eslint-disable-next-line eqeqeq
                    currentdate.getSeconds() == 0
        ) {
          this.LoadQuality()
          this.LoadEff()
        }
        // console.log(currentdate)
      }, 1000)
    },
    keeplocation () {
      this.keeploc(this.pagename, this.location)
    },
    getloc () {
      const postjson = {
        authen: {
          keycode: this.$keycode
        },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename
        }
      }
      axios({
        method: 'post',
        url: `${this.$apiflask}/log/getloc`, // php
        data: postjson
      }).then((res) => {
        if (res.data.loc != null) {
          this.location = res.data.loc
        }
      })
    },
    CurrDate () {
      let params = new FormData()
      axios({
        method: 'post',
        url: this.$api + 'Page05.php/curdate',
        data: params
      }).then((res) => {
        this.date = res.data.dte
        this.ex_date_from = res.data.dte
        this.LoadQuality()
      })
    },
    LoadDept () {
      try {
        this.departments = []
        let params = new FormData()
        params.append('location', this.location)
        axios({
          method: 'post',
          url: this.$api + 'ws_shopfloor.php/getdatalist-department',
          data: params
        }).then((res) => {
          if (res.data.status) {
            res.data.vdata.forEach((e) => {
              this.departments.push(e.DEPARTMENT)
            })
          } else {
            this.departments = []
          }
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
      }
    },
    // filterLocation(val, update, abort) {
    //   update(() => {
    //     const needle = val.toLowerCase()
    //     this.departments = this.departments_all.filter(v => v.toLowerCase().indexOf(needle) > -1)
    //   })
    // },
    getMTD () {
      try {
        this.mtd_eff = 0
        this.mtd_qua = 0
        let params = new FormData()
        params.append('uid', '2002')
        params.append('location', this.location)
        params.append('jobdate', this.date)
        axios({
          method: 'post',
          url: this.$apiFix + 'Page05.php/mrd',
          data: params
        }).then((res) => {
          this.mtd_eff = res.data.mtd_by_eff
          this.mtd_qua = res.data.mtd_by_quality
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
      }
    },
    LoadEff () {
      try {
        this.visible1 = true
        this.qceff_per = 0
        this.eff_rate = 0
        this.mtd_eff = 0
        this.mtd_qua = 0
        this.dataEff = []
        this.aa = 0
        this.bb = 0
        let params = new FormData()
        params.append('uid', 'IT')
        params.append('location', this.location)
        params.append('dept', this.department)
        params.append('jobdate', this.date)
        axios({
          method: 'post',
          url: this.$api + 'ws_shopfloor.php/getdatasammary',
          // url: 'http://localhost/nygcontrolroom/api/ws_shopfloor.php/getdatasammary',
          data: params
        }).then((res) => {
          if (res.data.status) {
            console.log('getdatasammary')
            console.log(res.data)
            this.getMTD()
            let arr = res.data.vdata
            let result = []
            arr.forEach(function (a) {
              if (!this[a.line_name]) {
                this[a.line_name] = {
                  line_name: a.line_name,
                  job: 0,
                  qa_target: 0,
                  wcs_actual_qty: 0,
                  sam: 0,
                  minute: 0,
                  worker: 0,
                  eff: 0,
                  input_minutes: 0,
                  output_minutes: 0
                }
                result.push(this[a.line_name])
              }
              this[a.line_name].job += 1
              this[a.line_name].qa_target += parseFloat(a.qa_target)
              this[a.line_name].wcs_actual_qty += parseFloat(a.wcs_actual_qty)
              this[a.line_name].sam += parseFloat(
                (parseFloat(a.wcs_actual_qty) * parseFloat(a.smv)).toFixed(2)
              )
              this[a.line_name].minute += parseFloat(a.time_minutes)
              this[a.line_name].worker += parseFloat(a.worker)
              this[a.line_name].input_minutes += parseFloat(a.input_minutes)
              this[a.line_name].output_minutes += parseFloat(a.output_minutes)
              this[a.line_name].eff = parseFloat(a.eff)
            }, Object.create(null))

            this.dataEff = result

            let outputMinutes = 0
            let inputMinutes = 0
            let aa = 0
            let bb = 0
            result.forEach(function (a) {
              inputMinutes += a.input_minutes
              outputMinutes += a.output_minutes

              aa += a.qa_target
              bb += a.wcs_actual_qty
            })

            this.aa = aa
            this.bb = bb

            this.eff_rate = parseFloat(
              ((outputMinutes * 100) / inputMinutes).toFixed(1)
            )

            let output = 0
            let input = 0
            arr.forEach(function (row) {
              output += (row.qa_result_good * row.smv)
              input += (row.worker * row.time_minutes)
            })

            this.qceff_per = ((parseInt(output) / parseInt(input)) * 100)

            this.visible1 = false
          } else {
            this.dataEff = []
            this.qceff_per = 0
            this.visible1 = false
          }
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.visible1 = false
      }
    },
    LoadQuality () {
      try {
        this.visible1 = true

        this.dataQuality = []
        this.eff_target = 0
        this.eff_actual = 0

        this.qua_actual = 0
        this.qua_good = 0
        this.qua_rate = 0

        let params = new FormData()
        params.append('location', this.location)
        params.append('dept', this.department)
        params.append('jobdate', this.date)
        axios({
          method: 'post',
          url: this.$api + 'ws_shopfloor.php/getdataqc',
          // url: 'http://localhost/nygcontrolroom/api/ws_shopfloor.php/getdataqc',
          data: params
        }).then((res) => {
          if (res.data.status) {
            this.dataQuality = res.data.vdata
            this.qua_actual = 0
            this.qua_good = 0
            for (let i = 0; i < this.dataQuality.length; i++) {
              this.qua_actual += parseInt(this.dataQuality[i].total_qa_actual)
              this.qua_good += parseInt(this.dataQuality[i].total_qa_good)
            }
            console.log(this.qua_actual)
            console.log(this.qua_good)
            this.qua_rate = parseFloat(
              ((this.qua_good * 100) / this.qua_actual).toFixed(1)
            )
            this.visible1 = false
          } else {
            this.dataQuality = []
            this.visible1 = false
          }
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.visible1 = false
      }
    },
    calRateEff (target, actual) {
      if (parseInt(target) > 0) {
        return ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      } else {
        return 0
      }
    },
    calFaceEff (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      if (eff < 90) {
        return 'mood_bad'
      } else if (eff > 97) {
        return 'mood'
      } else {
        return 'mood_bad'
      }
    },
    calEffVal (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      return eff
    },
    calColorEff (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      if (eff < 90) {
        return 'red'
      } else if (eff > 97) {
        return 'green'
      } else {
        return 'orange'
      }
    },
    calColorEffBG (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      if (eff < 90) {
        return 'bg-red-3 text-center'
      } else if (eff > 97) {
        return 'bg-green-4 text-center'
      } else {
        return 'bg-orange-4 text-center'
      }
    },
    calColorEff2 (actual) {
      let eff = 0
      if (parseInt(actual) > 0) {
        eff = parseInt(actual)
      }
      if (eff < 90) {
        return 'red'
      } else if (eff > 97) {
        return 'green'
      } else {
        return 'orange'
      }
    },
    calRateQua (target, actual) {
      if (parseInt(target) > 0) {
        return ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      } else {
        return 0
      }
    },
    calFaceQua (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      if (eff < 95) {
        return 'mood_bad'
      } else if (eff > 97) {
        return 'mood'
      } else {
        return 'mood_bad'
      }
    },
    calColorQua (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      if (eff < 95) {
        return 'red'
      } else if (eff > 97) {
        return 'green'
      } else {
        return 'orange'
      }
    },
    calColorQuaBG (target, actual) {
      let eff = 0
      if (parseInt(target) > 0) {
        eff = ((parseInt(actual) * 100) / parseInt(target)).toFixed(1)
      }
      if (eff < 95) {
        return 'text-center bg-red-3'
      } else if (eff > 97) {
        return 'text-center bg-green-4'
      } else {
        return 'text-center bg-orange-4'
      }
    },
    getClassSize () {
      if (this.$q.screen.width <= 1440) {
        return 'text-h5'
      } else {
        return 'text-h4'
      }
    }
  }
}
